import React from 'react'
import BtnWithChevron from '../BtnWithChevron'
import styles from './filter-menu-section.module.scss'
import { ClassNamesProps } from 'types/utilities'
import cx from 'classnames'

type ClassKeys = 'container' | 'label' | 'filterBtn'

interface Props extends ClassNamesProps<ClassKeys> {
  onClick: () => void
  label: string
  labelSelection?: string
}

const FilterMenuSection = ({ onClick, label, labelSelection, classNames }: Props) => {
  return (
    <section className={cx(styles.container, classNames?.container)}>
      <h2 className={cx(styles.label, classNames?.label)}>{label}</h2>
      <BtnWithChevron onClick={onClick} className={cx(styles.btn, classNames?.filterBtn)}>
        {labelSelection}
      </BtnWithChevron>
    </section>
  )
}

export default FilterMenuSection
